import React, { useState, useEffect } from "react";
import Project from "../projects/Project";
import Hostel from "../hostel/Hostel";
import Question from "../newsfeed/Question";
import { Sch } from "../scholarships/Scholarship";
import { Inte } from "../internships/Internship";
import QuestionCard from "../newsfeed/QuestionCard";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { Item } from "../fyp/Seealready";
import { Item2 } from "../fyp/Listnew";

const SearchedData = ({ searchText, searchedData, searchType }) => {
  const [theSearchType, setTheSearchType] = useState("");
  useEffect(() => {
    // console.log("searchType", searchType);
    // console.log("final show data", searchedData);

    setTheSearchType(searchType);
  }, [searchType]);
  return (
    <div>
      {" "}
      {searchText.length == 0 ? (
        <div className="row mt-5">
          <Typography variant="h6">
            Search anything on this website. You can search posts, questions,
            FYPs, hostels, projects, scholarships, internships etc
          </Typography>
        </div>
      ) : (
        <div>
          {theSearchType == "Projects" &&
            searchedData.map((project) => <Project project={project} />)}
          {theSearchType == "Hostels" &&
            searchedData.map((hostel) => <Hostel hostel={hostel} />)}
          {theSearchType == "Questions" &&
            searchedData.map((question) => (
              <QuestionCard question={question} isSearchedData={true} />
            ))}
          {theSearchType == "New FYPs" && (
            <>
              {searchedData.map((f, i) => (
                <Item2 fyp={f} />
              ))}
            </>
          )}
          {theSearchType == "Already Created FYPs" && (
            <>
              {searchedData.map((f, i) => (
                <Item fyp={f} />
              ))}
            </>
          )}

          {theSearchType == "Scholarships" &&
            searchedData.map((sch) => <Sch sch={sch} />)}
          {theSearchType == "Internships" &&
            searchedData.map((inte) => <Inte inte={inte} />)}
        </div>
      )}
    </div>
  );
};

export default SearchedData;
